import { useIsNotebook } from '~/domains/common/hooks/mediaQueries';

import useStyles from './SubHeader.styles';

function SubHeaderBgr({
  anchorToBottom,
  gradientHeight,
  isQuickPicks,
  style,
}: {
  anchorToBottom?: boolean;
  gradientHeight?: number;
  isQuickPicks?: boolean;
  style?: React.CSSProperties;
}) {
  const { classes, cx } = useStyles({});
  const isNotebook = useIsNotebook();
  const stopColor = isQuickPicks ? '#34213C' : '#4BEBE2';

  return (
    <svg
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx(classes.svgBgr, anchorToBottom && classes.svgBgrBottomAnchored)}
      style={style}
    >
      <rect width="100%" height="100%" fill="#101113" />
      {isNotebook ? (
        <rect
          width="100%"
          height={gradientHeight ?? '100%'}
          fill="url(#subheader_gradient_small)"
          fillOpacity={isQuickPicks ? '0.7' : '0.1'}
        />
      ) : (
        <rect
          width="100%"
          height={gradientHeight ?? '100%'}
          fill="url(#subheader_gradient_big)"
          fillOpacity={isQuickPicks ? '1' : '0.20'}
        />
      )}
      <defs>
        <linearGradient
          id="subheader_gradient_big"
          x1="100%"
          y1="0"
          x2="100.195%"
          y2="167.332%"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={stopColor} stopOpacity="0" />
          <stop offset="1" stopColor={stopColor} />
        </linearGradient>
        <linearGradient
          id="subheader_gradient_small"
          x1="1024"
          y1="0"
          x2="1027"
          y2="83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={stopColor} stopOpacity="0" />
          <stop offset="1" stopColor={stopColor} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SubHeaderBgr;
